<script setup lang="ts">
import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  search?: string;
}

export interface ValidData {
  search: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.helpcenterSideBarBrowseForm"
    data-testid="helpcenterSideBarBrowseForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.search"
      size="lg"
      label="Search"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      hide-details
    />
    <KBtn
      type="submit"
      size="lg"
      priority="info"
      icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.helpcenterSideBarBrowseForm {
  display: flex;
}
  .field {
    width: 100%;
    margin-right: 12px;
  }
  .submit {
  }
</style>
